export enum MilestonePayoutStatus {
  pending = 1,
  cleared = 2
}
